import { useNavigate } from "react-router-dom";
import { DeleteIcon, EditIcon } from "../../assets/icons/Svgs";
import {
  showDeletedAlert,
  showErrorAlert,
  showQuestionDeleteAlert,
  showUpdateAlert,
} from "../../components/molecules/ShowAlert";
import { eliminarRegistro } from "../../services/registro.service";

// 🔧 Utilidad para formatear fecha
const formatearFecha = (fecha) => {
  if (!fecha) return "-";
  const dateObj = new Date(fecha);
  return dateObj.toLocaleDateString(); // Puedes personalizar el formato si lo deseas
};

export const CongeladoCard = ({ estudiante, index, onDelete }) => {
  const navigate = useNavigate();

  const {
    persona = {},
    estudiante: datosEstudiante = {},
    inscripcion = {},
    registro = {},
  } = estudiante || {};

  const {
    nombre = "",
    apellido = "",
    celular = "_",
  } = persona;

  const {
    tipoAdmision = "N/A",
    idEstudiante,
  } = datosEstudiante;

  const {
    grupo = {},
    tipoCongelacion = "N/A",
    fechaCongelado,
    idRegistro,
  } = registro;

  const {
    nombre: nombreGrupo = "N/A",
    modulo = {},
  } = grupo;

  const {
    nombre: nombreModulo = "N/A",
  } = modulo;

  const {
    programa = {},
  } = inscripcion;

  const {
    nombre: nombrePrograma = "N/A",
  } = programa;

  const fechaCongeladoFormatted = formatearFecha(fechaCongelado);

  const handleDelete = () => {
    showQuestionDeleteAlert({
      callback: async (result) => {
        if (!result.isConfirmed) return;
        try {
          await eliminarRegistro(idRegistro);
          showDeletedAlert({
            callback: () => onDelete?.(idEstudiante),
          });
        } catch (error) {
          console.error("Error al eliminar el registro:", error);
          showErrorAlert({});
        }
      },
    });
  };

  const handleUpdate = () => {
    showUpdateAlert({
      callback: () => navigate(`/estudiantes/actualizar/${idEstudiante}`),
    });
  };

  return (
    <tr className="bg-white hover:bg-gray-100 transition-colors duration-300 [&>td]:p-3 [&>td]:text-gray-700 [&>td]:whitespace-nowrap">
      <td className="font-medium border-r border-slate-200 border-t">{index + 1}</td>
      <td className="border-r border-slate-200 border-t">{nombre}</td>
      <td className="border-r border-slate-200 border-t">{apellido}</td>
      <td className="border-r border-slate-200 border-t">{celular}</td>
      <td className="border-r border-slate-200 border-t">{tipoAdmision}</td>
      <td className="border-r border-slate-200 border-t">{nombrePrograma}</td>
      <td className="border-r border-slate-200 border-t">{nombreGrupo}</td>
      <td className="border-r border-slate-200 border-t">{nombreModulo}</td>
      <td className="border-r border-slate-200 border-t">{tipoCongelacion}</td>
      <td className="border-r border-slate-200 border-t">{fechaCongeladoFormatted}</td>
    </tr>
  );
};
